module.exports = __webpack_public_path__ + "img/user-circle.e687ed21.svg";